<template>
  <div class="videostream" ref="streamContainer">
    <vplayer
      :playerOptions="this.getVideoOptions()"
      ref="vplayer"
      v-if="liveStreamSrc && liveStreamSrc.length > 1"
    />
    <Marquee color="black bottom mobile-top" />
    <Logo showHideMobile="mobileHide" />
    <div v-show="!streamIsPlaying" class="play-button" @click="playVideo">
      <div class="play-button__start">
        <div clas="play-button__icon">PLAY VIDEO!</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"

import Marquee from "./Marquee"
import Logo from "./Logo"

export default {
  name: "Stream",

  data: () => ({}),

  components: {
    Marquee,
    Logo
  },

  methods: {
    ...mapMutations("partyStore", ["setStreamIsPlaying"]),

    playVideo() {
      if (!this.streamIsPlaying) this.$refs["vplayer"].$el.children[0].play()
      this.setStreamIsPlaying(true)
    },
    getVideoOptions() {
      return {
        type: "application/x-mpegURL",
        autoplay: false,
        playsinline: true,
        controls: "progress",
        src: this.liveStreamSrc
      }
    }
  },

  computed: {
    ...mapState({
      liveStreamSrc: state => state.partyStore.activeParty.live_stream,
      streamIsPlaying: state => state.partyStore.streamIsPlaying
    })
  }
}
</script>

<style lang="scss">
.videostream {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;

  .vplayer {
    width: 100%;
    height: 100%;

    .player__controls {
      visibility: hidden;
    }
  }

  .play-button {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    @media screen and (max-width: 600px) {
      height: 50%;
      z-index: 5;
    }

    &__start {
      flex: 0 0 auto;
      width: 70px;
      height: 70px;
      border: 2px solid white;
      border-radius: 999px;
      font-family: "Karla", sans-serif;
      font-size: 20px;
      font-weight: bold;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: white;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);

      &:hover {
        background-color: white;
        color: black;
      }
    }
  }
}
</style>
